import { Box, Text } from '@optiaxiom/react';

export type SectionHeaderProps = {
  title: string;
};

export function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <Box px="8" py="8">
      <Text fontSize="sm" color="fg.tertiary" fontWeight="500">
        {title}
      </Text>
    </Box>
  );
}
